import { Directive, Input } from '@angular/core';
import { CdkTreeNodeDef } from '@angular/cdk/tree';

@Directive({
  selector: '[mcraiTreeNodeDef]',
  inputs: [
    'when: mcraiTreeNodeDefWhen'
  ],
  providers: [{ provide: CdkTreeNodeDef, useExisting: TreeNodeDefDirective }]
})
export class TreeNodeDefDirective<T> extends CdkTreeNodeDef<T> {

  @Input('mcraiTreeNode') data: T;

}